<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow p-4 border border-gray-200 dark:border-gray-700"
  >
    <div class="flex justify-between items-start mb-2">
      <div>
        <h3 class="font-medium text-gray-900 dark:text-white">{{ table.label }}</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ table.description }}</p>
      </div>
      <span
        class="bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 text-xs font-medium px-2.5 py-0.5 rounded"
      >
        {{ recordCount }} records
      </span>
    </div>
    <button
      @click="$emit('clear', table)"
      :disabled="recordCount === 0 || disabled"
      class="mt-3 w-full bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/50 disabled:opacity-50 disabled:cursor-not-allowed px-3 py-2 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
    >
      <TrashIcon class="h-4 w-4" />
      Wissen
    </button>
  </div>
</template>

<script setup>
import { TrashIcon } from '@heroicons/vue/24/outline'

defineProps({
  table: {
    type: Object,
    required: true
  },
  recordCount: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['clear'])
</script>
